import Box from '@mui/material/Box';
import { isEmpty, isNumber, map } from 'lodash';
import React from 'react';
import { Hidden, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import { SHOW_ECO_DATA } from '@/constants/flags';

import { Col } from '@/components/grid';
import { RATERS, SPACE } from '@/constants';
import SafetyRow from '@/components/safety-row';
import SaferPickBanner from '../safer-pick-banner';
import AncapReportDownloadLink from '../ancap-report-download-link';
import { tooltipCopy } from '../../tooltip-copy';
import { Callout } from '@/components/callout';
import { RATING_COPY } from '../../no-rating-copy';
import { H4 } from '@/components/type';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'ratingProvider' implicitly has an 'any' type.
const getRatingItems = ({ ratingProvider, ancapTestResults, ucsrTestResults, shouldUsePedestrianProtection }) => {
  const {
    activeSafetyAssist,
    adultOccupantProtection,
    childOccupantProtection,
    vulnerableRoadUserProtection,
    pedestrianProtection,
    overallScore,
  } = ancapTestResults;

  const { aggressivity, driverProtection, primarySafety } = ucsrTestResults;

  if (ratingProvider === RATERS.UCSR) {
    return [
      {
        id: 3,
        label: 'Driver Protection',
        feature: isNumber(driverProtection) ? driverProtection : `Not Available`,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'driverProtection' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
        tooltip: tooltipCopy[RATERS.UCSR].driverProtection,
      },
      {
        id: 4,
        label: 'Protection for Other Road Users',
        feature: isNumber(aggressivity) ? aggressivity : `Not Available`,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'protectionOtherRoadUsers' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
        tooltip: tooltipCopy[RATERS.UCSR].protectionOtherRoadUsers,
      },
      {
        id: 5,
        label: 'Crash Avoidance',
        feature: isNumber(primarySafety) ? primarySafety : `Not Available`,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'crashAvoidance' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
        tooltip: tooltipCopy[RATERS.UCSR].crashAvoidance,
      },
    ];
  }

  if (ratingProvider === RATERS.ANCAP && overallScore) {
    return [
      {
        id: 4,
        label: 'Overall Score',
        feature: overallScore,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'overallScore' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
        tooltip: tooltipCopy[RATERS.ANCAP].overallScore,
      },
      {
        id: 5,
        label: 'Pedestrian Protection',
        feature: pedestrianProtection,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'pedestrianProtection' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
        tooltip: tooltipCopy[RATERS.ANCAP].pedestrianProtection,
      },
    ];
  }

  if (ratingProvider === RATERS.ANCAP) {
    return [
      {
        id: 6,
        label: 'Active Safety Assist',
        feature: activeSafetyAssist,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'activeSafetyAssist' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
        tooltip: tooltipCopy[RATERS.ANCAP].activeSafetyAssist,
      },
      {
        id: 7,
        label: 'Adult Occupant Protection',
        feature: adultOccupantProtection,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'adultOccupantProtection' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
        tooltip: tooltipCopy[RATERS.ANCAP].adultOccupantProtection,
      },
      {
        id: 8,
        label: 'Child Occupant Protection',
        feature: childOccupantProtection,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'childOccupantProtection' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
        tooltip: tooltipCopy[RATERS.ANCAP].childOccupantProtection,
      },
      {
        id: 9,
        label: shouldUsePedestrianProtection ? 'Pedestrian Protection' : 'Vulnerable Road User Protection',
        feature: vulnerableRoadUserProtection || pedestrianProtection,
        tooltip:
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'vulnerableRoadUserProtection' does not exist on type 'Element | { driverProtection: Element; protectionOtherRoadUsers: Element; crashAvoidance: Element; activeSafetyAssist?: undefined; adultOccupantProtection?: undefined; childOccupantProtection?: undefined; overallScore?: undefined; pedestrianProtection?: undefined; vulnerableRoadUserProtection?: undefined; } | { ...; }'.
          tooltipCopy[RATERS.ANCAP].vulnerableRoadUserProtection || tooltipCopy[RATERS.ANCAP].pedestrianProtection,
      },
    ];
  }

  return [];
};

const SafetyAtAGlanceContent = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'ratingProvider' implicitly has an 'any' type.
  ratingProvider,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'ancapTestResults' implicitly has an 'any' type.
  ancapTestResults,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'ucsrTestResults' implicitly has an 'any' type.
  ucsrTestResults,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'shouldUsePedestrianProtection' implicitly has an 'any' type.
  shouldUsePedestrianProtection,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'saferPick' implicitly has an 'any' type.
  saferPick,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'nonRatingItems' implicitly has an 'any' type.
  nonRatingItems,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'ancapReportDownloadLink' implicitly has an 'any' type.
  ancapReportDownloadLink,
}) => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const ratingItems = getRatingItems({
    ratingProvider,
    ancapTestResults,
    ucsrTestResults,
    shouldUsePedestrianProtection,
  });

  const showRatingItems = !isEmpty(ratingItems);

  return (
    <Box p={6}>
      {!SHOW_ECO_DATA && (
        <Box px={2} mb={4}>
          <H4>Safety at a glance</H4>
        </Box>
      )}
      <Hidden smDown>
        <SaferPickBanner isSaferPick={saferPick} ratingProvider={ratingProvider} />
      </Hidden>
      <Box
        pt={SHOW_ECO_DATA ? undefined : 2}
        gap={SPACE.X1}
        display="flex"
        flexDirection={smUp && showRatingItems ? 'row' : 'column'}
      >
        {showRatingItems ? (
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element[]; sm: number; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, offset, width
          <Col sm={6}>
            {map(ratingItems, ({ id, label, feature, tooltip }) => {
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ key: number; label: string; feature: any; tooltip: any; }' is missing the following properties from type '{ label: any; feature: any; tooltip: any; starColor: any; maxStars: any; starAriaDescription: any; }': starColor, maxStars, starAriaDescription
              return <SafetyRow key={id} label={label} feature={feature} tooltip={tooltip} />;
            })}
          </Col>
        ) : (
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element; sm: number; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, offset, width
          <Col sm={12}>
            <Callout {...RATING_COPY[ratingProvider]} />
          </Col>
        )}
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: any[]; sm: number; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, offset, width */}
        <Col sm={6}>
          {nonRatingItems &&
            map(nonRatingItems, ({ id, label, feature, tooltip }) => (
              <Box key={id}>
                {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ label: any; feature: any; tooltip: any; }' is missing the following properties from type '{ label: any; feature: any; tooltip: any; starColor: any; maxStars: any; starAriaDescription: any; }': starColor, maxStars, starAriaDescription */}
                <SafetyRow label={label} feature={feature} tooltip={tooltip} />
              </Box>
            ))}
          <AncapReportDownloadLink href={ancapReportDownloadLink} />
        </Col>
      </Box>
    </Box>
  );
};

export default SafetyAtAGlanceContent;
